
import * as $ from 'jquery'
import { Component, OnInit} from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
//




//declare const hello: any;
@Component({
  selector: 'app-livewebinar',
  templateUrl: './videoorom.component.html',
  styleUrls: ['./videoorom.component.css']
})
export class VideooromComponent implements OnInit {
  private router: Router
	ngOnInit() {
    this.loadScripts();
    if(localStorage.getItem('userID') !='' || localStorage.getItem('userID') !=undefined)
    {
     // this.router.navigate(['/']);
    }
  //hello();
    /*
		$('button').click(function() {
			alert('GeeksForGeeks');
		});
    */




	}
  loadScripts()
  {
    const dynamicScripts = [
      'assets/js/janus.js',
      //'assets/js/videorromMeeting.js',
      'assets/js/videoroomtest.js',

   ];
   for (let i = 0; i < dynamicScripts.length; i++) {
    const node = document.createElement('script');
    node.src = dynamicScripts[i];
    node.type = 'text/javascript';
    node.async = false;
    document.getElementsByTagName('head')[0].appendChild(node);
  }
  }
}
